import {TypeSearchFilterOptions} from "../../../search/utils/TypeSearchFilterOptions";
import {getSearchResultsListNamePrefix} from "../../../tracking/google_tag_manager/ecommerce_events/gtm_impressions";
import {OfferDealType} from "../../utils/constants_offer";

export const getOfferListAffixes = (latestQuery: {offer_type: TypeSearchFilterOptions; deal_type: OfferDealType}) => ({
    gtmListPrefix: getSearchResultsListNamePrefix(latestQuery.offer_type),
    gtmListSuffix: latestQuery.deal_type === OfferDealType.SELL ? "sprzedaz" : latestQuery.deal_type === OfferDealType.RENT ? "wynajem" : "wszystkie"
});
